import { clsx } from 'clsx'
import { PicaImage } from 'component/Image/PicaImage'
import { Space } from 'component/Space'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { demo } from 'page/catalog/store/CatalogStore'
import { elements } from 'page/catalog/store/elements/ElementsStore'
import { useRef, useState } from 'react'
import { Item } from 'type/Item'
import css from './ImagePane.module.scss'

type Props = {
  item: Item
  reverse?: boolean
}

export const ImagePane = observer(({ item, reverse }: Props) => {
  const { ratio } = demo.it.product
  const images = reverse ? item.images.slice(0, 2).reverse() : item.images
  const ref = useRef<HTMLDivElement>(null)
  const [active, setActive] = useState(false)
  const first = images[0]
  const second = images[1]

  const onMouseEnter = useLatestCallback(() => {
    if (second) setActive(true)
  })

  const onMouseLeave = useLatestCallback(() => {
    setActive(false)
  })

  const onRef = useLatestCallback((element: HTMLImageElement | null) => {
    elements.onItem(item.item_id, element)
  })

  useEffectOnce(() => {
    const element = ref.current!
    if (!element) return

    element.addEventListener('mouseover', onMouseEnter)
    element.addEventListener('mouseleave', onMouseLeave)

    return () => {
      element.removeEventListener('mouseenter', onMouseEnter)
      element.removeEventListener('mouseleave', onMouseLeave)
    }
  })

  return <Space ref={ref} className={css.pane} ratio={ratio} center>
    <PicaImage onRef={onRef} className={clsx(css.first, !active && css.active)} src={first} />
    {second && <PicaImage className={clsx(css.second, active && css.active)} src={second} />}
  </Space>
})
